// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { VideoPlayerFactory } from "@outschool/ui-legacy-component-library";

const HlsVideo = () => import(/* webpackChunkName: "Video" */ "hls.js");
const VideoPlayer = VideoPlayerFactory(HlsVideo);
export default VideoPlayer;
